import { queryOptions } from '@tanstack/react-query';
import { api } from '@/shared/api';
import { apiRoutes } from '@/shared/routes';
import type { CatalogFacility, CountriesResponse } from './types';

function fetchCountries(): Promise<CountriesResponse> {
  return api.get<CountriesResponse>(apiRoutes.countries);
}

function fetchFacilities(countryCode: string): Promise<CatalogFacility[]> {
  const params = new URLSearchParams({ country: countryCode });
  return api.get<CatalogFacility[]>(`${apiRoutes.facilities}?${params}`);
}

export function facilitiesQuery(countryCode: string) {
  return queryOptions({
    queryKey: ['facilities', countryCode],
    queryFn: () => fetchFacilities(countryCode),
    staleTime: Infinity,
    enabled: !!countryCode,
  });
}

export function countriesQuery() {
  return queryOptions({
    queryKey: ['countries'],
    queryFn: fetchCountries,
    staleTime: Infinity,
  });
}
